// ================================
// 请求
// ================================
// 标准请求
export const STANDARD_REQ_ORDER = 100;
// 接口版本
export const API_VERSION_REQ_ORDER = 200;
// 应用令牌
export const APP_TOKEN_REQ_ORDER = 300;
// 用户令牌
export const USER_TOKEN_REQ_ORDER = 400;
// ================================
// 响应
// ================================
// 接口版本
export const API_VERSION_RES_ORDER = 100;
// 标准响应
export const STANDARD_RES_ORDER = 200;
// ================================
// 错误
// ================================
// 标准错误
export const STANDARD_ERR_ORDER = 100;
// 错误处理
export const PROCESS_FAULT_ERR_ORDER = 200;
